import { Link } from "react-router-dom";

function Home() {
  return (
    <>
      <div className="position-relative d-flex align-items-center">
        <video
          autoPlay
          muted
          loop
          className="w-100 object-fit-cover"
          height="580"
        >
          <source src="/assets/videos/1.mp4" type="video/mp4" />
        </video>
        <div className="video-backdrop"></div>
        <div className="position-absolute w-100 p-0 z-2">
          <div className="container">
            <div className="col-lg-8 col-12">
              <h2 className="display-5 text-white fw-medium lh-1 ls-sm">
                Microfinance Bazar
              </h2>
              <h1 className="display-3 text-white fw-bold lh-1 ls-sm">
                Worldwide community Strategies for Addressing Poverty
              </h1>
            </div>
          </div>
        </div>
      </div>

      <section class="position-relative z-1 mt-hero-video">
        <div class="container">
          <div class="bg-primary rounded-5 py-5 px-5 d-flex justify-content-center text-center">
            <div class="col-md-9 col-12 mt-4">
              <span class="text-white ls-md text-uppercase fw-semibold">
                Pay the Fortune
              </span>
              <h2 class="display-5 text-white">
                Economic Empowerment & Gender Equality
              </h2>
              <p class="lead text-white opacity-75 px-lg-8 mb-5 fw-normal lh-sm">
                Our mission is to improve the lives of underserved people by
                building innovative and responsible financial solutions.
              </p>
              <div class="d-grid d-md-block mb-3">
                <a
                  class="btn btn-primary border border-light px-5 btn-md mb-2"
                  href="/mission-vision"
                >
                  Read More
                </a>
                <a
                  class="btn btn-light px-5 btn-md ms-2 mb-2"
                  href="/introduction"
                >
                  Why Microfinance ?
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="pt-lg-7 pb-lg-3 py-5 mt-2">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-lg-6 col-md-12 col-12">
              <div class="pe-lg-6">
                <span className="badge bg-danger-soft rounded-pill fs-5 px-4 mb-2">
                  About <span className="fw-bold">Microfinance Bazar</span>
                </span>

                <h1 class="display-5 fw-bold my-3 ls-sm lh-1">
                  Microfinancebazar creates new avenues for rural partnerships
                </h1>
                <p class="mb-3 h3 lh-1">
                  We are offering opportunities for borrowers, suppliers and
                  lender as a business correspondent while fostering meaningful
                  human connections.
                </p>
                <div class="mt-3">
                  <div class="mb-2">
                    <div>
                      <h4 class="mb-1 fw-semibold">Financial Inclusion</h4>
                      <p class="mb-3 fs-4 lh-sm">
                        We provide a range of resources, including small loans,
                        secure savings accounts, and financial education, to
                        assist individuals in increasing their income and
                        achieving financial stability.
                      </p>
                    </div>
                    <div>
                      <h4 class="mb-1 fw-semibold">
                        Investing in rural enterpreneurs
                      </h4>
                      <p class="mb-0 fs-4 lh-sm">
                        We support enterprises that develop products and
                        services aimed at empowering marginalized communities to
                        foster resilience and generate prosperity.
                      </p>
                    </div>
                  </div>
                </div>
                <a
                  class="btn btn-dark px-5 btn-md mt-3 mb-lg-0 mb-5"
                  href="/introduction"
                >
                  About Us
                </a>
              </div>
            </div>
            <div class="col-lg-6 col-md-12 col-12">
              <img
                src="/assets/images/home/9.jpg"
                class="object-fit-cover w-100 rounded-5"
                height="550"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="pb-4 bg-white">
        <div className="container mb-lg-5">
          <div className="row my-5">
            <div className="col-lg-8 col-md-12 col-12">
              <span class="text-black ls-md text-uppercase fw-semibold">
                40 Years of Impact
              </span>
              <h2 className="mb-2 display-4 fw-bold text-dark lh-1 mt-1">
                Know more{" "}
                <u class="text-primary">
                  <span class="text-primary">about us</span>
                </u>
              </h2>
              <p className="lead text-dark lh-sm lh-1">
                Achieving gender equality With women is essential for
                successfully combating poverty.
              </p>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-6 col-12">
              <img
                src="/assets/images/map.jpg"
                className="w-100 rounded-5 mb-lg-0 mb-4"
                height="360"
              />
            </div>
            <div className="col-lg-6 col-12 d-flex justify-content-center flex-column">
              <div className="ms-4">
                <div>
                  <p className="statistics__stat lh-1 m-0">14.5M+</p>
                  <p className="fs-4 fs-normal m-0 lh-1">Clients Served</p>
                </div>
                <div className="mt-3">
                  <p className="display-3 lh-1 m-0">45+</p>
                  <p className="fs-4 fs-normal m-0 lh-1">Countries Served</p>
                </div>
                <div className="mt-3">
                  <p className="display-3 lh-1 m-0">80%</p>
                  <p className="fs-4 fs-normal m-0 lh-1">
                    Clients are self employed / farmers
                  </p>
                </div>
                <div className="mt-3">
                  <a
                    class="btn btn-outline-dark px-5 btn-md mt-3 mb-lg-0 mb-5 me-1"
                    href="/introduction"
                  >
                    Join Microfinance Bazar
                  </a>
                  <a
                    class="btn btn-dark px-5 btn-md mt-3 mb-lg-0 mb-5"
                    href="/introduction"
                  >
                    Know More
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="pt-5 bg-image pb-8">
        <div className="container mt-5">
          <div className="row">
            <div className="col-lg-5 col-md-12 py-8 my-8">
              <div className="position-relative z-3">
                <h1 className="display-4 ls-sm mt-2 fw-bold text-white">
                  Our Work
                </h1>
                <p className="mb-6 display-5 lh-1 text-white ls-sm">
                  Economic Empowerment and Gender Equality
                </p>

                <a
                  class="btn border border-light text-white rounded-pill px-5 btn-md mb-2"
                  href="/mission-vision"
                >
                  Read More
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="pt-2 pb-0 bg-white">
        <div className="container mt-7">
          <div className="row">
            <div className="col-xl-6 col-lg-6 col-md-12 d-flex align-items-center">
              <div className="mb-4 mb-xl-0 text-center text-md-start">
                <span className="badge bg-danger-soft rounded-pill fs-5 px-4 mb-3">
                  Contact Us
                </span>
                <h1 className="display-4 fw-bold mb-3 ls-sm lh-1">
                  LOAN and REWARD Program for Women
                </h1>
                <p className="mb-4 lead lh-sm">
                  We provide local training to foster relationship with our
                  Rural Customers, we are enabling villages to manage their
                  farms and rural businesses with greater efficiency by
                  collaborating with financial institutions enhancing access to
                  financing to women entrepreneurs in rural areas.
                </p>
                <p className="mb-4 lead lh-sm">
                  Our Reward program for reference customers and awareness
                  empowers village women to promote a secure and healthy
                  community.
                </p>
                <div className="mb-4 mb-0">
                  <ul className="list-unstyled fs-4">
                    <li>
                      <span className="me-2">
                        <i className="bi bi-star text-warning" />
                      </span>
                      <span className="align-text-top">Emergency loans</span>
                    </li>
                    <li>
                      <span className="me-2">
                        <i className="bi bi-star text-warning" />
                      </span>
                      <span className="align-text-top">Housing loans</span>
                    </li>
                    <li>
                      <span className="me-2">
                        <i className="bi bi-star text-warning" />
                      </span>
                      <span className="align-text-top">
                        Income-generating loans
                      </span>
                    </li>
                  </ul>
                </div>
                <div>
                  <a
                    class="btn btn-outline-dark px-5 btn-md mt-3 mb-lg-0 mb-5 me-1"
                    href="/introduction"
                  >
                    Join Microfinance Bazar
                  </a>
                  <a
                    class="btn btn-dark px-5 btn-md mt-3 mb-lg-0 mb-5"
                    href="/introduction"
                  >
                    Know More
                  </a>
                </div>
              </div>
            </div>
            <div className="offset-xxl-1 col-xxl-5 col-lg-6 col-md-12">
              <div className="card smooth-shadow-md rounded-5 mt-lg-0 mt-4">
                <div className="card-body px-6 pt-5 pb-4">
                  <div className="mb-4 bg-dark p-3 rounded-5 py-4">
                    <h1 className="mb-0 lh-1 fw-bold text-white h3 text-center">
                      Contact MicrofinanceBazar
                    </h1>
                    <p className="lead text-center text-white m-0 fs-4">
                      Get in touch with our team
                    </p>
                  </div>
                  <form className="needs-validation" noValidate="">
                    <div className="mb-2">
                      <input
                        type="email"
                        id="courseLeadEmail"
                        className="form-control rounded-pill px-4"
                        placeholder="Full Name"
                        required=""
                      />
                    </div>
                    <div className="mb-2">
                      <input
                        type="email"
                        id="courseLeadEmail"
                        className="form-control rounded-pill px-4"
                        placeholder="Phone No"
                        required=""
                      />
                    </div>
                    <div className="mb-2">
                      <input
                        type="email"
                        id="courseLeadEmail"
                        className="form-control rounded-pill px-4"
                        placeholder="Email"
                        required=""
                      />
                    </div>
                    <div className="mb-2">
                      <input
                        type="password"
                        id="courseLeadPassword"
                        className="form-control rounded-pill px-4"
                        placeholder="Subject"
                        required=""
                      />
                    </div>
                    <div className="mb-2">
                      <textarea
                        type="text"
                        className="form-control rounded-4 px-4"
                        placeholder="Complete Address"
                        rows="2"
                        required=""
                      ></textarea>
                    </div>
                    <div className="d-grid">
                      <button
                        type="submit"
                        className="btn btn-primary rounded-pill"
                      >
                        Send Message
                      </button>
                    </div>
                  </form>
                </div>
                <div className="card-footer rounded-5 px-6 py-4">
                  <p className="mb-0 text-center">
                    By continuing you accept the{" "}
                    <a
                      href="#"
                      className="text-inherit fw-semibold text-decoration-underline"
                    >
                      Privacy Policy
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="pb-8">
        <div className="container mt-7 mb-2">
          <div className="row pt-2">
            <div className="col-12">
              <div className="row text-center d-flex justify-content-center">
                <div className="col-lg-7 col-md-12 px-lg-8 mb-3">
                  <span className="badge bg-dark-soft rounded-pill fs-5 px-4 mb-2">
                    <span className="fw-bold">FAQs</span> - Microfinance Bazar
                  </span>
                  <h1 class="fw-bold mb-0">
                    Do you want more{" "}
                    <u class="text-primary">
                      <span class="text-dark">information?</span>
                    </u>
                  </h1>
                  <p className="lead lh-sm mt-2">
                    Dive into our FAQs to find detailed insights, helpful tips,
                    and everything you need to know about Microfinance Bazar.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-6 col-md-12 col-12">
              <div className="mb-4 mb-lg-0 pe-lg-5">
                <img
                  src="/assets/images/home/4.jpg"
                  alt="featured"
                  className="w-100 rounded-5 object-fit-cover"
                  height="500"
                />
              </div>
            </div>
            <div className="col-lg-6 pb-lg-0 pb-4 d-flex align-items-center">
              <div
                className="accordion accordion-flush w-100 pe-lg-5 pe-0 me-lg-5 me-0"
                id="accordionFlushExample"
              >
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button px-0 bg-white"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseOne"
                      aria-expanded="true"
                      aria-controls="flush-collapseOne"
                    >
                      <h3 className="faqs-text text-dark fw-medium m-0">
                        What is MicrofinanceBazar?
                      </h3>
                    </button>
                  </h2>
                  <div
                    id="flush-collapseOne"
                    className="accordion-collapse collapse"
                    data-bs-parent="#accordionFlushExample"
                    style={{}}
                  >
                    <div className="accordion-body px-0">
                      <p className="fs-4 fw-light mb-4 text-secondary lh-sm">
                        MicrofinanceBazar refers to digital Fintech intermediary
                        providing financial services like loans, savings, and
                        insurance to low-income individuals or groups who do not
                        have access to traditional banking services. It helps
                        people start or expand small businesses, improve their
                        living standards, and break the cycle of poverty.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button px-0 bg-white collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseThree"
                      aria-expanded="false"
                      aria-controls="flush-collapseThree"
                    >
                      <h3 className="faqs-text text-dark fw-medium m-0">
                        Who is eligible for a MicrofinanceBazar loan?
                      </h3>
                    </button>
                  </h2>
                  <div
                    id="flush-collapseThree"
                    className="accordion-collapse collapse show"
                    data-bs-parent="#accordionFlushExample"
                    style={{}}
                  >
                    <div className="accordion-body px-0">
                      <p className="fs-4 fw-light mb-4 text-secondary lh-sm">
                        Eligibility for microfinance loans typically includes:
                        <ul>
                          <li>
                            Income group: Low-income individuals/ females,
                            Physically Disabled, Transgenders.
                          </li>
                          <li>
                            Business/Income source: Small businesses,
                            self-employed individuals, farmers, or those in the
                            informal sector.
                          </li>
                          <li>
                            Geography: Individuals living in rural or semi-urban
                            areas, where access to traditional banking services
                            may be limited.
                          </li>
                          <li>
                            Credit history: MicrofinanceBazar assesses the
                            creditworthiness of borrowers and co-borrowers,
                            which can change depending on the scheme.
                          </li>
                        </ul>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button px-0 bg-white collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseTwo"
                      aria-expanded="false"
                      aria-controls="flush-collapseTwo"
                    >
                      <h3 className="faqs-text text-dark fw-medium m-0">
                        How much money can I borrow?
                      </h3>
                    </button>
                  </h2>
                  <div
                    id="flush-collapseTwo"
                    className="accordion-collapse collapse"
                    data-bs-parent="#accordionFlushExample"
                    style={{}}
                  >
                    <div className="accordion-body px-0">
                      <p className="fs-4 fw-light mb-4 text-secondary lh-sm">
                        The minimum loan amount is INR 5,000. The borrower's
                        ability to repay the loan can range loan limit from
                        ₹10,000 to ₹2,00,000, depending on the eligibility.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button px-0 bg-white collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseFour"
                      aria-expanded="false"
                      aria-controls="flush-collapseFour"
                    >
                      <h3 className="faqs-text text-dark fw-medium m-0">
                        How can I repay my monthly loan repayments?
                      </h3>
                    </button>
                  </h2>
                  <div
                    id="flush-collapseFour"
                    className="accordion-collapse collapse"
                    data-bs-parent="#accordionFlushExample"
                    style={{}}
                  >
                    <div className="accordion-body px-0">
                      <p className="fs-4 fw-light mb-4 text-secondary lh-sm">
                        You can pay by monthly amortization installments,
                        starting one month after the loan disbursement and
                        payable via the borrower's designated loan-linked
                        Deposit Account with MicrofinanceBazar.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="pt-lg-2 pb-lg-3 py-5 mb-7">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-lg-6 col-md-12 col-12">
              <div class="pe-lg-6">
                <span className="badge bg-danger-soft rounded-pill fs-5 px-4 mb-2">
                  Financial Inclusion
                </span>

                <h2 class="fw-semibold my-3 ls-sm lh-1">
                  Financial Assistance, Savings Programs, and Training to
                  developing Unbanked, Transgender and Physically Disabled
                  Communities.
                </h2>
                <p class="mb-3 h3 lh-1">
                  The profound effect that small loans and fundamentals of
                  Digital Financial Education by Microfinancebazar REWARDS
                  program have empowering individuals to alleviate poverty.
                </p>
                <div class="mt-3">
                  <div class="mb-2">
                    <div>
                      <p class="mb-3 fs-4 lh-sm">
                        Our microfinance model has developed into a worldwide
                        network that is changing lives across numerous
                        low-income nations.
                      </p>
                    </div>
                    <div>
                      <p class="mb-0 fs-4 lh-sm">
                        Today, <u>MICROFINANCEBAZAR</u> is at the forefront of merging
                        technology with responsible microfinance practices. We
                        are expanding our services by utilizing digital tools to
                        reach underserved communities, including individuals
                        living in the most remote regions of the world.
                      </p>
                    </div>
                  </div>
                </div>
                <a
                  class="btn btn-outline-dark px-5 btn-md mt-4 mb-lg-0 mb-5"
                  href="/introduction"
                >
                  Why MicrofinanceBazar ?
                </a>
              </div>
            </div>
            <div class="col-lg-6 col-md-12 col-12">
              <img
                src="/assets/images/home/7.jpg"
                class="object-fit-cover w-100 rounded-5"
                height="550"
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Home;
